import m from "../../geodata/es2015/cyprusNorthCyprusLow";
window.am4geodata_cyprusNorthCyprusLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/cyprusNorthCyprusLow.js
// module id = null
// module chunks = 